import ImportInProgress from 'modules/job_catalog/components/JobCatalogTree/ImportInProgress'
import { ResponsivePage } from 'modules/layout/components/ResponsivePage'

const JobCatalogTreeImportInProgressPage = () => {
  return (
    <ResponsivePage.Body showHeader={false}>
      <ImportInProgress />
    </ResponsivePage.Body>
  )
}

export default JobCatalogTreeImportInProgressPage
